import { render } from "./MerchantContactSuccess.vue?vue&type=template&id=6055ca12&scoped=true"
import script from "./MerchantContactSuccess.vue?vue&type=script&lang=js"
export * from "./MerchantContactSuccess.vue?vue&type=script&lang=js"

import "./MerchantContactSuccess.vue?vue&type=style&index=0&id=6055ca12&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6055ca12"]])

export default __exports__